<template>
  <div>
    <div
      v-if="showViewModal"
      class="fixed inset-0 z-50 flex items-center justify-center mt-5 overflow-x-hidden overflow-y-auto outline-none md:mt-5 focus:outline-none"
    >
      <div class="relative w-[35rem] h-full p-4 md:h-auto">
        <div class="relative bg-white shadow rounded-xl">
          <div class="flex items-center justify-between px-2 py-4">
            <p class="pl-2 font-medium text-black">Share</p>
            <button
              type="button"
              class="absolute right-0 flex items-center justify-center p-1 ml-auto text-sm font-thin text-black bg-transparent bg-gray-200 rounded-full w-14 hover:text-gray-900"
              @click="closeViewModal"
              data-modal-toggle="show-login-modal"
            >
              <svg
                aria-hidden="true"
                class="w-5 h-5"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                  clip-rule="evenodd"
                ></path>
              </svg>
              <span class="sr-only">Close modal</span>
            </button>
          </div>
          <hr />

          <div class="flex flex-col p-8 space-y-4">
            <button
              @click="shareFacebook"
              class="flex items-center justify-center w-full h-12 font-medium border rounded-lg text-primary border-primary"
            >
              <svg
                version="1.1"
                id="Layer_1"
                width="20"
                height="20"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                viewBox="0 0 28.2 50"
                style="enable-background: new 0 0 28.2 50"
                xml:space="preserve"
              >
                <g>
                  <g
                    id="XMLID_00000000205115836981067070000017096679050326786236_"
                  >
                    <g
                      id="XMLID_00000145771447644720169260000015857211295962114949_"
                    >
                      <path
                        class="st0"
                        d="M19.4,50H7.8V28.7H0v-11h7.8v-5.2c0-4,1.3-7.5,3.8-9.8c2.1-2,4.9-2.9,8.1-2.7l8.3,0.4v9.5h-5.2
				c-1.6,0-3.3,0.9-3.3,2.6v5.3h8.4l-1.7,11h-6.6V50z M10.2,47.6H17V26.3h7l1-6.2h-8v-7.7c0-3.1,2.9-5,5.7-5h2.8V2.7l-6-0.3
				C17,2.3,14.8,3,13.2,4.5c-1.9,1.8-3,4.7-3,8v7.6H2.4v6.2h7.8V47.6z"
                      />
                    </g>
                  </g>
                </g>
              </svg>
              <span class="pl-1">Facebook</span>
            </button>
            <button
              @click="shareWhatsApp"
              class="flex items-center justify-center w-full h-12 font-medium border rounded-lg text-primary border-primary"
            >
              <svg
                version="1.1"
                id="Layer_1"
                width="20"
                height="20"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                viewBox="0 0 50 48.3"
                style="enable-background: new 0 0 50 48.3"
                xml:space="preserve"
              >
                <g>
                  <path
                    class="st0"
                    d="M25.8,48.3c-4.9,0-9.6-1.4-13.6-4.2L0,48.1L4.8,36c-2-3.6-3.1-7.7-3.1-11.8C1.7,10.8,12.5,0,25.8,0
		C39.2,0,50,10.8,50,24.2S39.2,48.3,25.8,48.3z M12.6,41.6l0.5,0.3c3.7,2.7,8.1,4.1,12.7,4.1c12,0,21.8-9.8,21.8-21.8
		c0-12-9.8-21.8-21.8-21.8C13.8,2.3,4,12.1,4,24.2c0,3.9,1.1,7.8,3.1,11.1l0.3,0.5L4,44.3L12.6,41.6z"
                  />
                </g>
              </svg>
              <span class="pl-1">WhatsApp</span>
            </button>
            <button
              @click="shareTwitter"
              class="flex items-center justify-center w-full h-12 font-medium border rounded-lg text-primary border-primary"
            >
              <svg
                version="1.1"
                id="Layer_1"
                width="20"
                height="20"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                viewBox="0 0 50 46.8"
                style="enable-background: new 0 0 50 46.8"
                xml:space="preserve"
              >
                <g
                  id="layer1_00000024693763436990233800000010213559145047665795_"
                  transform="translate(52.390088,-25.058597)"
                >
                  <path
                    id="path1009_00000085229666689979530830000017235983217224565670_"
                    class="st0"
                    d="M-2.5,71.9L-21.8,46l19.4-21h-4.4
		l-17,18.4l-13.7-18.4h-14.9L-32,52.3l-18.1,19.5h4.4L-30,54.9l12.7,16.9H-2.5z M-8.9,68.6h-6.8L-46,28.3h6.8L-8.9,68.6z"
                  />
                </g>
              </svg>
              <span class="pl-1">Twitter</span>
            </button>
            <button
              @click="shareEmail"
              class="flex items-center justify-center w-full h-12 font-medium border rounded-lg text-primary border-primary"
            >
              <svg
                version="1.1"
                id="Layer_1"
                width="20"
                height="20"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                viewBox="0 0 50 41"
                style="enable-background: new 0 0 50 41"
                xml:space="preserve"
              >
                <path
                  class="st0"
                  d="M50,0.9c0,0,0-0.1-0.1-0.1c0,0,0-0.1-0.1-0.1c0,0,0-0.1-0.1-0.1c0,0,0-0.1-0.1-0.1C49.4,0.1,49-0.1,48.6,0H1.2
	c-0.5,0-1,0.3-1.1,0.8c-0.2,0.5,0,1,0.4,1.3L20,16l-0.2,23.9c0,0.5,0.3,1,0.8,1.1c0.1,0,0.2,0.1,0.4,0.1c0.4,0,0.7-0.2,0.9-0.5
	L49.6,2.1C49.9,1.8,50.1,1.3,50,0.9z M43.9,2.4L21.3,14L4.8,2.4H43.9z M22.3,16.1L45,4.5L22.2,36.2L22.3,16.1z"
                />
              </svg>
              <span class="pl-1"> Email</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="showViewModal"
      class="fixed inset-0 z-40 bg-black opacity-25"
    ></div>
  </div>
</template>

<script setup>
import { getCurrentInstance, defineProps } from "vue";
import { useRouter } from "vue-router";

const props = defineProps({
  showViewModal: Boolean,
  content: Object,
});
const { emit } = getCurrentInstance();
const router = useRouter();

const closeViewModal = () => {
  emit("closeViewModal");
};

const getContentUrl = () => {
  const { id, title } = props.content;
  const slug = title.replace(/\s+/g, "-").toLowerCase(); // Simple slug generation
  return router.resolve({ name: "PropertyView", params: { id, slug } }).href;
};

const getShortDescription = (description) => {
  return (
    description.split(" ").slice(0, 20).join(" ") +
    (description.split(" ").length > 20 ? "..." : "")
  );
};

const getImageUrl = (relativePath) => {
  return `${relativePath}`;
};

const shareWhatsApp = () => {
  const baseUrl = window.location.origin;
  const { title, description, photos } = props.content;
  const url = getContentUrl();
  const shortDescription = getShortDescription(description);
  const imageUrl = photos.length > 0 ? getImageUrl(photos[0]) : "";
  const shareUrl = `https://wa.me/?text=${encodeURIComponent(
    title
  )}%0A${encodeURIComponent(shortDescription)}%0A${encodeURIComponent(
    `${baseUrl}${url}`
  )}%0A${encodeURIComponent(imageUrl)}`;
  window.open(shareUrl, "_blank");
};
const shareFacebook = () => {
  const baseUrl = window.location.origin;
  const { title, description, photos } = props.content;
  const url = getContentUrl();
  const image = photos[0] ? getImageUrl(photos[0]) : null;
  const shortDescription = getShortDescription(description);
  const shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
    `${baseUrl}${url}`
  )}&quote=${encodeURIComponent(title + " - " + shortDescription)}${
    image ? "&picture=" + encodeURIComponent(image) : ""
  }`;
  window.open(shareUrl, "_blank");
};

const shareTwitter = () => {
  const { title, photos } = props.content;
  const url = getContentUrl();
  const image = photos[0] ? getImageUrl(photos[0]) : null;
  const shareUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(
    title
  )}&url=${encodeURIComponent(url)}&via=YourTwitterHandle${
    image ? "&media=" + encodeURIComponent(image) : ""
  }`;
  window.open(shareUrl, "_blank");
};

const shareEmail = () => {
  const { title, description, photos } = props.content;
  const url = getContentUrl();
  const image = photos[0] ? getImageUrl(photos[0]) : null;
  const shortDescription = getShortDescription(description);
  const subject = title;
  const body = `${shortDescription}%0A${url}${
    image ? "%0A" + encodeURIComponent(image) : ""
  }`;
  const shareUrl = `mailto:?subject=${encodeURIComponent(
    subject
  )}&body=${encodeURIComponent(body)}`;
  window.location.href = shareUrl;
};
</script>

<style scoped>
.st0 {
  fill: #d11f26;
}

.share-buttons {
  display: flex;
  gap: 10px;
}

button {
  padding: 10px 20px;
  cursor: pointer;
}
</style>
